// web-common/src/errors.js — the /v1 answer taxonomy (D1-DESIGN §2.2). The seam's BUSINESS
// answers ride HTTP 200; transport/auth problems ride 4xx/5xx. classify() normalizes both
// into ONE { kind, ... } shape so screens switch on one field and never re-parse bodies.
//
// kinds: ok | insufficient_credits | needs_confirm | refused | invalid | auth | error
//
// Pure — suite-pinned against fixture bodies copied from the real handlers
// (harness/test/v2/client-commands.test.js).

export const KINDS = ['ok', 'insufficient_credits', 'needs_confirm', 'refused', 'invalid', 'auth', 'error'];

// classify(status, body) -> { kind, status, body, ...convenience fields }
export function classify(status, body) {
  const b = body && typeof body === 'object' ? body : {};
  const base = { status, body: b };
  if (status === 401 || status === 403) {
    return { ...base, kind: 'auth', error: b.error || (status === 401 ? 'unauthenticated' : 'forbidden') };
  }
  if (status === 400) {
    return { ...base, kind: 'invalid', error: b.error || 'invalid request', errors: Array.isArray(b.errors) ? b.errors : [] };
  }
  if (status >= 200 && status < 300) {
    // C1 §2.2 — the out-of-credits refusal, WITH the price (never re-derive client-side)
    if (b.refused && b.insufficient_credits) {
      return {
        ...base, kind: 'insufficient_credits', error: b.error || 'insufficient credits',
        credits_required: Number(b.credits_required) || 0,
        credits_balance: Number(b.credits_balance) || 0,
        quote: b.quote || null,
      };
    }
    if (b.needs_confirm) {
      return { ...base, kind: 'needs_confirm', quote: b.quote || null, note: b.note || null, op: b.op || null, routed: b.routed === true };
    }
    if (b.refused) {
      // the seam's refusal messages are written for humans — show error VERBATIM, never rephrase
      return { ...base, kind: 'refused', error: b.error || 'refused', quote: b.quote || null };
    }
    if (b.invalid) {
      return { ...base, kind: 'invalid', error: 'invalid command', errors: Array.isArray(b.errors) ? b.errors : [] };
    }
    // body fields spread for convenience (job_id/existing/…) but the ENVELOPE wins on
    // collisions — a job row carries its own `kind` ('create'…) which must never clobber
    // the taxonomy's kind:'ok' (caught live on the Generating watcher; suite-pinned).
    return { ...b, ...base, kind: 'ok' };
  }
  // 404 / 409 / 5xx / anything else — a retryable error card; 409 carries the server's reason
  return { ...base, kind: 'error', error: b.error || `HTTP ${status}` };
}

// classifyNetworkError(err) — a fetch that never reached the server
export function classifyNetworkError(err) {
  return { kind: 'error', status: 0, body: null, error: 'network error: ' + (err && err.message ? err.message : String(err)) };
}
